module.exports = "//static.hsappstatic.net/conversations-visitor-ui/static-1.9449/audio/notification.mp3"